import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { ApiService } from '../api.service';
import { CURRENCY } from '../../environments/environment';
import {
  RATE_TYPE_FIXED, RATE_TYPE_PER_MONTH,
   RATE_TYPE_FREE, RATE_TYPE_PER_CLASS, RATE_TYPE_PER_HOUR,
 
} from 'src/app/constants';


@Component({
  selector: 'app-class-search-details',
  templateUrl: './class-details.component.html',
  styleUrls: ['./class-details.component.scss']
})
export class ClassDetailsComponent implements OnInit {
  scheduleID:string;
  pkgID:string;
  courseStatus:string;
  courseDetails:any;
  course_schedule:any;
  faculty:any;
  package_contents:any;
  vendorType:string;
  vendorTypeList:any;
  vendorTypeName:string;
  vendorTypeId:string;
  vendorTypes:number;
  specialityList:any;
  speciality:string;
  specialityName:string;
  ageGroup:string;
  batchName:string;
  occuranceType:string;
  startDate:string;
  endDate:string;
  startTime:string;
  endTime:string;
  numberOfHours:string;
  priceRateTypeName:string;
  priceRateTypeId:string;
  whatsappURL:string;
  deliveryMode:string;
  instructionChannel:string;
  joining:string;
  courseName:string;
  lowPrice:string;
  highPrice:string;
  registrationCharges:string;
  userID:string;
  description:string;
  package_features:any;
  businessName:string;
  vendorID:string;
  currency:string;
  courseID:string;
  category:string;
  coursePriceId:string;
 

  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private apiService: ApiService) {
      this.scheduleID = this.activatedRoute.snapshot.paramMap.get('scheduleId');      
      this.pkgID = this.activatedRoute.snapshot.paramMap.get('packageId');
      

     }

  ngOnInit() {

    this.currency = CURRENCY;  
    
    
    let packageData = {
      token: localStorage.getItem("token_data"),
      userID: localStorage.getItem("userID"),
      hostID: localStorage.getItem("hostID"),
      courseID: this.pkgID,
      scheduleID: this.scheduleID,
      
    }

    this.apiService.studentCourseDetails(packageData).subscribe((res:any)=>{    
     
      this.courseDetails = res.data.courseDetails.data.courseDetails[0];      
      this.course_schedule = res.data.courseDetails.data.course_schedule;
      this.faculty = res.data.courseDetails.data.faculty;
      this.package_contents = res.data.courseDetails.data.package_contents;
      this.package_features = res.data.courseDetails.data.package_features;

      console.log(this.package_features);

      this.getVendorType();
      this.getSpecilityType();


      this.vendorTypes = res.data.courseDetails.data.courseDetails[0].vendorTypes;    
      
      this.speciality = res.data.courseDetails.data.courseDetails[0].speciality;
      this.ageGroup = res.data.courseDetails.data.courseDetails[0].ageGroup;

      this.courseName = res.data.courseDetails.data.courseDetails[0].packageName;
      this.courseID = res.data.courseDetails.data.courseDetails[0].id;
      this.lowPrice =  res.data.courseDetails.data.courseDetails[0].lowPrice;
      this.highPrice = res.data.courseDetails.data.courseDetails[0].highPrice;
      this.registrationCharges = res.data.courseDetails.data.courseDetails[0].registrationCharges;
      this.courseStatus =  res.data.courseDetails.data.courseDetails[0].status;
      this.description = res.data.courseDetails.data.courseDetails[0].description;
      this.businessName = res.data.courseDetails.data.courseDetails[0].businessName;
      this.coursePriceId = res.data.courseDetails.data.courseDetails[0].priceRateTypeId;

      this.batchName = res.data.courseDetails.data.course_schedule[0].batchName;
      this.occuranceType = res.data.courseDetails.data.course_schedule[0].occuranceType;
      this.startDate = res.data.courseDetails.data.course_schedule[0].startDate;
      this.endDate = res.data.courseDetails.data.course_schedule[0].endDate;
      this.startTime = res.data.courseDetails.data.course_schedule[0].startTime;
      this.endTime = res.data.courseDetails.data.course_schedule[0].endTime;
      this.numberOfHours = res.data.courseDetails.data.course_schedule[0].numberOfHours;
      this.priceRateTypeName = res.data.courseDetails.data.course_schedule[0].priceRateTypeName;
      this.whatsappURL = res.data.courseDetails.data.course_schedule[0].whatsappURL;
      this.deliveryMode = res.data.courseDetails.data.course_schedule[0].deliveryMode;
      this.instructionChannel = res.data.courseDetails.data.course_schedule[0].instructionChannel;
      this.joining = res.data.courseDetails.data.course_schedule[0].joining;
      this.priceRateTypeId = res.data.courseDetails.data.course_schedule[0].priceRateTypeId;


      this.package_features = res.data.courseDetails.data.package_features;
      


    }, async err => {
        
    })

    


  }

  getVendorType(){

    let vendorTypeData = {
      token:localStorage.getItem("token_data"),
      userID: localStorage.getItem("userID"),
      hostID: localStorage.getItem("hostID"),
      courseID: this.pkgID,
      scheduleID: this.vendorID,
      pkgID: this.pkgID
     }
  
    this.apiService.getVenDetails(vendorTypeData).subscribe((res:any)=>{      
       this.vendorTypeList = res.data.venDetails.data;     
      this.vendorTypeList.forEach(obj => {             
       if( this.vendorTypes == obj.id  ){
          this.vendorTypeName = obj.vendorTypeName;             
                
       }  
                
      })      

    }, async err => {

    })

  }

  getSpecilityType(){
    let specialityData = {
      token:localStorage.getItem("token_data"),
      userID: localStorage.getItem("userID"),
      hostID: localStorage.getItem("hostID"),
      courseID: this.pkgID,
      scheduleID: this.vendorID,
      pkgID: this.pkgID
    }
    this.apiService.getSpecialityData(specialityData).subscribe((res:any)=>{    
      
      this.specialityList = res.data.specialityData.data;
      this.specialityList.forEach(obj1 => {                   
        if(this.speciality == obj1.id ){
           this.specialityName = obj1.specialityName;  
        }  
            
       })      
    }) 


  }

  getRateText(priceRateTypeId) {
    if (!priceRateTypeId) {
      return "";
    }

    if (priceRateTypeId === 1) {
      return RATE_TYPE_FIXED;
    } else if (priceRateTypeId === 2) {
      return RATE_TYPE_PER_MONTH;
    }
    else if (priceRateTypeId === 3) {
      return RATE_TYPE_FREE;
    }
    else if (priceRateTypeId === 4) {
      return RATE_TYPE_PER_CLASS;
    }
    else
      return RATE_TYPE_PER_HOUR;
  }

  makeEnrollment(vendorID,courseID){
    this.userID = localStorage.getItem(`userID`);
    if(this.userID==null){
      this.router.navigateByUrl(`login`);
    }
    else {
      this.router.navigateByUrl(`create-enrollment/`+vendorID +`/`+ courseID);
    }
      

  }
  InstituteDetails(vendorID){  
    this.router.navigateByUrl(`profile/`+vendorID);
  }
  request(vendorID,courseID){

    
    this.userID = localStorage.getItem(`userID`);
    
    if(this.userID==null){
      this.router.navigateByUrl(`login`);
    }
    else {
      this.router.navigateByUrl(`create-enquiry/`+ vendorID + `/` +courseID );
    }
    
  }

}
